export const useParseTimeToSeconds = (time: string): number => {
	let totalSeconds = 0;

	const hoursMatch = time.match(/(\d+)\s*ч/);
	const minutesMatch = time.match(/(\d+)\s*м/);
	const secondsMatch = time.match(/(\d+)\s*с/);

	if (hoursMatch) totalSeconds += parseInt(hoursMatch[1], 10) * 3600;
	if (minutesMatch) totalSeconds += parseInt(minutesMatch[1], 10) * 60;
	if (secondsMatch) totalSeconds += parseInt(secondsMatch[1], 10);

	return totalSeconds;
};
